import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsServicedeskJourneyConfigurationEditRoute } from '@jira/router-routes__project-settings-service-desk-journeys-routes/src/projectSettingsServicedeskJourneyConfigurationEditRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { journeyConfigEditPageEntryPoint } from './ui/journey-config-edit/index.tsx';

export const projectSettingsServicedeskJourneyConfigurationEditRouteEntry: Route = createEntry(
	projectSettingsServicedeskJourneyConfigurationEditRoute,
	() => ({
		group: 'project-settings-servicedesk',

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		meta: {
			reporting: {
				id: 'jsm.journey-builder.journey-config',
				packageName: camelCase('journey-config'),
				teamName: 'JSM Grape Soju',
			},
		},

		layout: serviceProjectLayout,
		resources: [...getServiceDeskSettingsResources()],
		perfMetricKey: 'jsm-journey-configuration-edit',
		entryPoint: () => journeyConfigEditPageEntryPoint,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
